export const errorBoundaryRu = {
  title: 'Что-то пошло не так',
  description: 'Произошла непредвиденная ошибка. Попробуйте перезагрузить страницу.',
  technicalDetails: 'Технические детали',
  tryAgain: 'Попробовать снова',
  backToHome: 'Вернуться на главную',
  contactSupport: 'свяжитесь с поддержкой',
  supportText: 'Если проблема повторяется,',
};
